import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { RunnerSetupDeleteWarnings } from './RunnerSetupDeleteWarnings';

export const runnerSetupDeleteWarningsBridge = react2angular(RunnerSetupDeleteWarnings, [
  'entityName',
  'warnings',
  'deleteConfirmed',
  'entityType'
]);
